import { render, staticRenderFns } from "./m-restricted-table-header-cell.vue?vue&type=template&id=6f566fcc&scoped=true&"
import script from "./m-restricted-table-header-cell.vue?vue&type=script&lang=js&"
export * from "./m-restricted-table-header-cell.vue?vue&type=script&lang=js&"
import style0 from "./m-restricted-table-header-cell.vue?vue&type=style&index=0&id=6f566fcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f566fcc",
  null
  
)

export default component.exports